import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PlanoSaude } from '../plano-saude';
import { PlanoSaudeService } from '../plano-saude.service';

@Component({
  selector: 'app-plano-saude-maintenance',
  templateUrl: './plano-saude-maintenance.component.html',
  styleUrls: ['./plano-saude-maintenance.component.css']
})
export class PlanoSaudeMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  planoSaude: PlanoSaude;

  formularioPlanoSaude: FormGroup;

  tituloCrud: string = '';

  constructor(private planoSaudeService: PlanoSaudeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.planoSaude = new PlanoSaude();

    this.formularioPlanoSaude = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(3)]],
      ativo: new FormControl(false),
      interno: new FormControl(false),
      qtdDiasPeriodoVolta: null,
      qtdAtdMes: null,
      atdOutroMedicoPerVolta: new FormControl(false),
      indCobrarProcConsulta: new FormControl(false),
      observacao: [''],
      observacaoConsulta: [''],
      planoSaudeProcedimento: []
    });

  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Plano Saúde';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Plano Saúde';
      }
    } else {
      this.tituloCrud = 'Criar Plano Saúde';
    }

    this.configurarForm();
  }

  save() {

    this.planoSaude = this.formularioPlanoSaude.value;

    this.configureCheckBoxValues();

    if (this.isNew()) {
      this.planoSaudeService
        .criar(this.planoSaude).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.planoSaudeService.atualizar(this.planoSaude, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/planoSaude']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioPlanoSaude.controls;
  }

  configurarForm(): void {
    if (!this.isNew()) {
      this.planoSaudeService.procurarPlanoSaudePorIdSemRelacionamento(this.id)
        .subscribe(data => {
          // console.log(data)

          this.planoSaude = data;

          this.formularioPlanoSaude.setValue(this.planoSaude);

          this.cd.detectChanges();

          if (this.isUpdate == 'N') {
            this.formularioPlanoSaude.disable();
          }
        }, error => {
          console.log(error);
        });
    } else {
      this.formularioPlanoSaude.setValue({
        id: 0,
        nome: '',
        ativo: false,
        interno: false,
        qtdDiasPeriodoVolta: null,
        qtdAtdMes: null,
        atdOutroMedicoPerVolta: false,
        indCobrarProcConsulta: false,
        observacao: '',
        observacaoConsulta: '',
        planoSaudeProcedimento: [],
      });
    }
  }

  configureCheckBoxValues() {

    if (!this.planoSaude.ativo) {
      this.planoSaude.ativo = false;
    }

    if (!this.planoSaude.interno) {
      this.planoSaude.interno = false;
    }

    if (!this.planoSaude.atdOutroMedicoPerVolta) {
      this.planoSaude.atdOutroMedicoPerVolta = false;
    }

    if (!this.planoSaude.ativo) {
      this.planoSaude.ativo = false;
    }
  }
}
